import {gql} from 'apollo-angular';
import {ImageFragment} from "../../fragments/Image";
import {StatusFragment} from "../../fragments/Status";

export const GET_CLICK_PIC_QUESTION = gql`
  query GetClickPicQuestion($gameId: Int!, $round: Int!) {
    getClickThePicQuestion(gameID: $gameId, round: $round) {
      id,
      status {
        ... statusFields
      },
      image {
        ...imageFields
      },
      answers {
        id,
        text
      }
    }
  }

  ${StatusFragment}
  ${ImageFragment}
`;
